var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35842 14.5958C4.36221 14.5958 4.366 14.5958 4.36979 14.5958C4.67108 14.5749 11.7695 14.082 13.5413 12.1237C14.4148 11.1569 14.862 9.9047 14.7995 8.60108C14.737 7.29555 14.1723 6.0947 13.2097 5.21546C11.2219 3.40371 8.13502 3.55215 6.33105 5.54851C4.56497 7.50109 4.20872 14.141 4.19545 14.4227C4.19356 14.4702 4.21062 14.5159 4.24473 14.5502C4.27315 14.5787 4.31483 14.5958 4.35842 14.5958Z",
    fill: "#7F4BD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDot);
export default __webpack_public_path__ + "static/media/p-dot.6e7c01aa684a5ab4894add13fe9e6113.svg";
export { ForwardRef as ReactComponent };